
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[region]/[resort]/bewertungen",
      function () {
        return require("private-next-pages/[region]/[resort]/bewertungen.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[region]/[resort]/bewertungen"])
      });
    }
  